import { LoaderContainerVariantType } from '../../../../../components/loaderContainer/types/loaderContainer';
export const getLoaderContainerStyles = (FOUNDATIONS) => {
    return {
        [LoaderContainerVariantType.DEFAULT]: {
            container: {
                width: '100%',
                height: '100%',
                background_color: FOUNDATIONS.color_neutral_screen_bg_175,
                display: 'flex',
                align_content: 'center',
                align_items: 'center',
                pointer_events: 'none',
                cursor: 'wait',
                justify_content: 'center',
            },
        },
    };
};
//# sourceMappingURL=styles.js.map